import { actionType } from "../utils/helpers/generalHelper";
import * as ProfileConstants from "../constants/profile.constant";
import ProfileService from "../services/profile.service";
import ErrorHelper from "../utils/helpers/errorHelper";
import { toast } from "react-hot-toast";
import cookieHelper from "../utils/helpers/cookieHelper";
import { configs } from "../utils/helpers/constants";

export const editUserProfile = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(ProfileConstants.UPDATE_USER_PROFILE_REQUEST));
    const data = await ProfileService.updateProfile(payload);
    console.log({ data });
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(ProfileConstants.UPDATE_USER_PROFILE_SUCCESS, responseData)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    // expiredTokenCheck(error, dispatch);
    dispatch(actionType(ProfileConstants.UPDATE_USER_PROFILE_FAILURE));
    toast.error(message);
  }
};

export const getProfile = () => async (dispatch) => {
  try {
    dispatch(actionType(ProfileConstants.FETCH_USER_PROFILE_REQUEST));
    const data = await ProfileService.fetchUserProfile();
    if (data.status !== 200) {
      throw data;
    }

    const responseData = data.data;
    const accountStatus = responseData["accountStatus"];
    await cookieHelper.set(
      configs.USER_ACTIVATED_STATUS,
      accountStatus,
      configs.COOKIE_EXPIRY_PERIOD
    );
    dispatch(
      actionType(ProfileConstants.FETCH_USER_PROFILE_SUCCESS, responseData)
    );
  } catch (error) {
    // let message = ErrorHelper.getApiErrorMessage(error);
    // expiredTokenCheck(error, dispatch);
    dispatch(actionType(ProfileConstants.FETCH_USER_PROFILE_FAILURE));
    // toast.error(message);
  }
};

export const uploadProfilePicture = (image, link) => async (dispatch) => {
  try {
    dispatch(actionType(ProfileConstants.UPDATE_PROFILE_PICTURE_REQUEST));
    const data = await ProfileService.uploadProfilePicture(image);
    console.log("data => ", data);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(ProfileConstants.UPDATE_PROFILE_PICTURE_SUCCESS, responseData)
    );
    toast.success("Profile picture uploaded successfully");
    // link();
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(ProfileConstants.UPDATE_PROFILE_PICTURE_FAILURE));
    toast.error(message);
  }
};
